import React, { useCallback, useRef, useState } from 'react';
import axios from '../../sagas/axios';
import ModalAlert from '../../components/modal/modal_alert';
import ModalLoader from '../../../modal/modal_loader';
import DatePicker, { registerLocale } from "react-datepicker";
import ja from "date-fns/locale/ja";
registerLocale("ja", ja);

const Edit = ({ suguboEvent = [], isNew = false }) => {
  const today = new Date()
  let day = new Date()
  const tomorrow = day.setDate(day.getDate() + 1);
  const [contents, setContents] = useState(suguboEvent.contents ? suguboEvent.contents : '');
  const [place, setPlace] = useState(suguboEvent.place ? suguboEvent.place : '');
  const [eventDate, setEventDate] = useState(suguboEvent.event_date ? new Date(suguboEvent.event_date) : '');
  const [event, setEvent] = useState([]);
  const [focused, setFocused] = useState(false);
  const [minNumOfPeople, setMinNumOfPeople] = useState(suguboEvent.min_num_of_people ? suguboEvent.min_num_of_people : 2);
  const [capacity, setCapacity] = useState(suguboEvent.capacity ? suguboEvent.capacity : 2);
  const successRef = useRef(null);
  const errorRef = useRef(null);
  const loaderRef = useRef(null);

  const onSubmit = useCallback(
    (e) => {
      e.preventDefault();
      loaderRef.current.openModal();
      const body = JSON.stringify({
        contents: contents,
        event_date: eventDate,
        place: place,
        capacity: capacity,
        min_num_of_people: minNumOfPeople,
      });
      if(isNew){
      axios
        .post(`/api/sugubo_events`, body)
        .then((response) => {
          loaderRef.current.closeModal();
          if (response.data) {
            setEvent(response.data.event)
            successRef.current.openModal();
          } else {
            errorRef.current.openModal();
          }
        })
        .catch(() => {
          loaderRef.current.closeModal();
          errorRef.current.openModal();
        });
      } else {
        axios
        .patch(`/api/sugubo_events/${suguboEvent.id}`, body)
        .then((response) => {
          loaderRef.current.closeModal();
          if (response.data) {
            setEvent(response.data.event)
            successRef.current.openModal();
          } else {
            errorRef.current.openModal();
          }
        })
        .catch(() => {
          loaderRef.current.closeModal();
          errorRef.current.openModal();
        });
      }
    },
    [
      loaderRef,
      successRef,
      errorRef,
      contents,
      eventDate,
      place,
      capacity,
      minNumOfPeople,
    ]
  );

  const toEventShowPage = useCallback(() => {
    window && (window.location.href = `/sugubo_events/${event.id}`);
  });

  return (
    <div>
      <main className="bg-gray h-100 pt-3 min-vh-100">
        <div className="container col-md-8 col-lg-6 mt-4 px-4">
          <h1 className="mb-4 mt-5 text-center text-fz-26px text-fw-bold">スグ募！😃しよう</h1>
          <div className="mb-5 text-center">
            <p className="mb-4 mt-5 text-black-333 text-left text-fz-16px">
              「スグ募！」は、すぐに少人数で集まれる新しいサービスです。<br/><br/>

              ・企画者は無料<br/>
              ・参加者は手数料500円（VIPメンバーは無料）<br/>
              ・今日か明日に限り<br/>
              ・（自分を含め）2〜4人の少人数だけ<br/>
              で募集できます。
            </p>

            <p className="mb-4 mt-5 text-black-333 text-left text-fz-12px">
              <span className="text-fw-bold text-fz-16px">【参加者審査制】</span><br/><br/>
              ・参加希望者は、参加手数料（500円）の仮決済とともに参加申請をします。<br/>
              ・企画者は参加申請の通知を受け取ってから<span className="text-fw-bold">30分以内</span>（夜間20:00〜8:00の申請分については翌朝9:00まで）に「承認」か「非承認」を選択しなくてはなりません。もし承認しない場合は、申請は自動的に非承認になります。<br/>
              ・非承認になった場合、参加申請者には手数料は全額払い戻しされます。<br/>
              </p>
          </div>
        </div>
        <div className="container col-md-8 col-lg-6 px-3 py-3">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-1 d-inline-block">
            本文
            <span className="text-fz-14px text-fw-bold text-orange mb-2 mt-1 ml-2 d-inline-block">
              必須
            </span>
          </p>
          <textarea
            id="body"
            className={`p-1 w-100 form-control ${ !focused && contents.length == 0 && 'text-gray' }`}
            onBlur={() => setFocused(false)}
            onFocus={() => setFocused(true)}
            value={ !focused && contents.length == 0
              ? '3/27の夜に鬼滅の刃の映画をいっしょに観に行きませんか？\nTOHOシネマズ渋谷にいっしょに来てくれる人を募集します！\n同じ年代の20代〜30代の方が来てくれると嬉しいです！\n\n時間の調整もできますので、お気軽にご連絡ください！'
              : contents
            }
            onChange={(e) => setContents(e.target.value)}
            rows="9"
          />
        </div>
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-2 d-inline-block">
            イベント日時
            <span className="text-fz-14px text-fw-bold text-orange mb-2 mt-1 ml-2 d-inline-block">
              必須
            </span>
            <p className="text-fz-small text-black-50 text-fw-normal mb-2">
              ※今日か明日の時刻のみ選択できます。
            </p>
            {!isNew && (
              <p className="text-fz-small text-danger mb-2">
                ※集合時刻は変更できません。
              </p>
            )}
          </p>
        </div>
        <div className="shadow-sm mb-3 bg-white">
          <div className="container col-md-8 col-lg-6">
            <label
              htmlFor="event-start-datetime-input-form"
              className="row justify-content-between p-3_5"
            >
              <p className="p-0 mb-0">集合時刻</p>
              <DatePicker
                className="text-right"
                dateFormat="yyyy/MM/dd HH:mm"
                locale="ja"
                selected={eventDate}
                onChange={date => setEventDate(date)}
                placeholderText="必須"
                showTimeSelect
                timeIntervals={30}
                minDate={today}
                maxDate={tomorrow}
                disabled={!isNew}
              />
            </label>
          </div>
        </div>
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            場所
            <span className="text-fz-14px text-fw-bold text-gray mb-0 mt-1 ml-2 d-inline-block">
              必須
            </span>
          </p>
          <p className="text-fz-small text-black-50 mb-3">
            ※現在は、渋谷・新宿・池袋付近でのみ募集できます。
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <div className="row justify-content-between p-1">
              <p className="col-4 pr-2 m-0">集合場所</p>
              <input
                id="place"
                value={place}
                onChange={(e) => setPlace(e.target.value)}
                className="col-8 p-0 textarea--eventreport text-right"
                placeholder="渋谷駅モヤイ像前"
              />
            </div>
          </div>
        </div>
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-0 mt-5 d-inline-block">
            人数（自分を含む）
            <span className="text-fz-14px text-fw-bold text-gray mb-0 mt-1 ml-2 d-inline-block">
              必須
            </span>
          </p>
          <p className="text-fz-small text-black-50 mb-3">
            ※2〜4人
          </p>
        </div>
        <div className="shadow-sm mb-3 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <div className="row justify-content-between p-1">
              <p className="col-4 pr-2 m-0 pt-2">最小人数</p>
              <select
                className="form-control text-right"
                style={{ width: '50%', display: "inline-block", border: "none" }}
                name="min_num_of_people"
                id="min_num_of_people"
                onChange={(e) => {
                  setMinNumOfPeople(Number(e.target.value))
                  if (capacity < Number(e.target.value)){
                    setCapacity(Number(e.target.value))
                  }
                }}
                value={minNumOfPeople}
              >
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
              </select>
            </div>
          </div>
          <div className="container col-md-8 col-lg-6 p-3_5">
            <div className="row justify-content-between p-1">
              <p className="col-4 pr-2 m-0 pt-2">最大人数</p>
              <select
                className="form-control text-right"
                style={{ width: '50%', display: "inline-block", border: "none" }}
                name="capacity"
                id="capacity"
                onChange={(e) => setCapacity(Number(e.target.value))}
                value={capacity}
              >
                <option value="2" disabled={2 < minNumOfPeople}>2</option>
                <option value="3" disabled={3 < minNumOfPeople}>3</option>
                <option value="4">4</option>
              </select>
            </div>
          </div>
        </div>
        <div className="container col-md-8 col-lg-6 mt-5 mb-5 pb-5">
          <button
            type="button"
            className="col-6 a-button a-button__top bg-tunagate-gradation text-white w-100"
            onClick={(e) => onSubmit(e)}
            disabled={contents === '' || eventDate === '' || place === ''}
          >
            公開する
          </button>
        </div>
      </main>
      <ModalAlert
        ref={successRef}
        name="スグ募作成完了"
        content="作成に成功しました。"
        approveFunc={toEventShowPage}
      />
      <ModalAlert
        ref={errorRef}
        name="スグ募作成失敗"
        content="作成に失敗しました。時間をおいてもう一度お試しください。"
      />
      <ModalLoader ref={loaderRef} />
    </div>
  );
};

export default Edit;
